(function () {
  var sliders = [];

  function pageSize(track) {
    return Math.max(track.clientWidth * 0.9, 1);
  }

  function pageCount(track) {
    var max = track.scrollWidth - track.clientWidth;
    if (max <= 8) return 1;
    return Math.ceil((max + 1) / pageSize(track)) + 1;
  }

  function currentPage(track) {
    var max = track.scrollWidth - track.clientWidth;
    if (max <= 8) return 0;
    var pages = pageCount(track);
    return Math.min(pages - 1, Math.round((track.scrollLeft / max) * (pages - 1)));
  }

  function renderDots(root, track) {
    var holder = root.querySelector('[data-scroll-dots]');
    if (!holder) return;
    var pages = pageCount(track);
    var active = currentPage(track);
    if (holder.childElementCount !== pages) {
      holder.innerHTML = '';
      for (var i = 0; i < pages; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'product-scroll__dot';
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        dot.setAttribute('data-scroll-page', String(i));
        holder.appendChild(dot);
      }
    }
    Array.prototype.forEach.call(holder.children, function (dot, i) {
      dot.classList.toggle('is-active', i === active);
      dot.setAttribute('aria-current', i === active ? 'true' : 'false');
    });
  }

  function sync(root) {
    var track = root.querySelector('[data-product-scroll]');
    if (!track) return;
    var prev = root.querySelector('[data-scroll-prev]');
    var next = root.querySelector('[data-scroll-next]');
    var max = track.scrollWidth - track.clientWidth;
    var pages = pageCount(track);
    root.classList.toggle('is-static', pages <= 1);
    if (prev) prev.disabled = track.scrollLeft <= 8;
    if (next) next.disabled = track.scrollLeft >= max - 8;
    renderDots(root, track);
  }

  function goTo(track, page) {
    var pages = pageCount(track);
    var max = track.scrollWidth - track.clientWidth;
    var left = pages <= 1 ? 0 : (page / (pages - 1)) * max;
    track.scrollTo({ left: left, behavior: 'smooth' });
  }

  function bind(root) {
    if (root.getAttribute('data-scroll-ready')) return;
    var track = root.querySelector('[data-product-scroll]');
    if (!track) return;
    root.setAttribute('data-scroll-ready', 'true');

    var prev = root.querySelector('[data-scroll-prev]');
    var next = root.querySelector('[data-scroll-next]');
    var dots = root.querySelector('[data-scroll-dots]');

    if (prev) {
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -pageSize(track), behavior: 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        track.scrollBy({ left: pageSize(track), behavior: 'smooth' });
      });
    }
    if (dots) {
      dots.addEventListener('click', function (event) {
        var btn = event.target.closest('[data-scroll-page]');
        if (!btn) return;
        goTo(track, parseInt(btn.getAttribute('data-scroll-page'), 10) || 0);
      });
    }

    track.addEventListener('scroll', function () {
      sync(root);
    }, { passive: true });

    if (typeof ResizeObserver !== 'undefined') {
      var observer = new ResizeObserver(function () { sync(root); });
      observer.observe(track);
    }

    sliders.push(root);
    sync(root);
  }

  function init(scope) {
    var root = scope || document;
    var nodes = root.querySelectorAll ? root.querySelectorAll('.js-product-scroll') : [];
    if (root.classList && root.classList.contains('js-product-scroll')) {
      bind(root);
    }
    Array.prototype.forEach.call(nodes, bind);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  window.addEventListener('resize', function () {
    sliders.forEach(sync);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }
})();
